<section appScrollManager>
  <div class="section-navigation">
    <button
      mat-button
      routerLink="."
      appScrollAnchor="masterData"
      [ngClass]="{'active': isActiveRoute['masterData']}"
      (click)="updateActiveRoutes('masterData')">
      Stammdaten
    </button>
    <button
      mat-button
      routerLink="."
      appScrollAnchor="skillData"
      [ngClass]="{'active': isActiveRoute['skillData']}"
      (click)="updateActiveRoutes('skillData')">
      Skilldaten
    </button>
    <button
      mat-button
      routerLink="."
      appScrollAnchor="projectData"
      [ngClass]="{'active': isActiveRoute['projectData']}"
      (click)="updateActiveRoutes('projectData')">
      Projektdaten
    </button>
  </div>
  <div *ngIf="cv" class="cv-data">
    <div *ngIf="isConsultantCV() && isCurrentUser" class="back-block">
      <button mat-button routerLink="/cv-list">
        <mat-icon svgIcon="arrow_back"></mat-icon>
        <span>{{'back_to_all_cvs' | translate}}</span>
      </button>
    </div>
    <div *ngIf="!isCurrentUser" style="margin-bottom: 16px;" class="back-block">
      <button mat-button routerLink="/search">
        <mat-icon svgIcon="arrow_back"></mat-icon>
        <span>{{'back_to_all_cvs' | translate}}</span>
      </button>
    </div>
    <div *ngIf="isConsultantCV()" class="edit-cv-header">
      <div class="edit-cv-title">
          <span class="title-label">CV in {{ language }}:</span>
          <button mat-button color="primary" (click)="downloadDocX(cv)">
            <mat-icon svgIcon="download"
                      matTooltip="{{'download_cv' | translate}}"
                      matTooltipPosition="above"
                      matTooltipShowDelay="100">
            </mat-icon>
            <span>CV Download</span>
          </button>
      </div>
      <div>
        <span class="form-control" style="background-color: #EFF0F0;"> {{ this.cv.name }}</span>
      </div>
    </div>
    <div class="section-wrapper">
      <app-master-data
        #masterData
        appScrollSection="masterData"
        [id]="cv?.id"
        [cvType]="cv?.cvType"
        [masterData]="cv?.masterData"
        [image]="cv?.image"
        (userDtoEmmiter)="handleMasterDataChange($event)"
        (cvParseHandler)="handleParsedCV($event)"
        (masterDataChanged)="markMasterDataDirty($event)">
      </app-master-data>
      <app-skill-data
        #skillData
        appScrollSection="skillData"
        [cvId]="cv?.id"
        [cvType]="cv?.cvType"
        [skills]="cv?.skill || emptySkill"
        (skillChangeHandler)="handleSkillChange($event)"
        (skillsChanged)="markSkillsDirty($event)">
      </app-skill-data>
      <app-project-data
        #projectData
        appScrollSection="projectData"
        [cvId]="cv?.id"
        [cvType]="cv?.cvType"
        [projects]="cv?.projects || []"
        (projectsChangeHandler)="handleProjectChange($event)"
        (projectsChanged)="markProjectsDirty($event)">
      </app-project-data>
    </div>
  </div>
</section>

